"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE64 = void 0;
var BASE64 = /** @class */ (function () {
    function BASE64() {
    }
    BASE64.encode = function (str) {
        return Buffer.from(str).toString('base64');
    };
    BASE64.decode = function (str) {
        return Buffer.from(str, 'base64').toString('ascii');
    };
    return BASE64;
}());
exports.BASE64 = BASE64;
